"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformScienceUnitsResponseSchema = exports.PlatformScienceUnitSchema = exports.PlatformScienceDriversResponseSchema = exports.PlatformScienceDriverSchema = exports.PlatformScienceDriverRecordSchema = exports.PlatformScienceCustomerInfoResponseSchema = void 0;
const zod_1 = require("zod");
const driverFieldMaxLength_1 = require("./driverFieldMaxLength");
exports.PlatformScienceCustomerInfoResponseSchema = zod_1.z.object({
    customer: zod_1.z.object({
        id: zod_1.z.string(),
        name: zod_1.z.string(),
    }),
});
exports.PlatformScienceDriverRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string().nullable().optional(),
    lastName: zod_1.z.string().nullable().optional(),
    login: zod_1.z.string().nullable().optional(),
});
exports.PlatformScienceDriverSchema = exports.PlatformScienceDriverRecordSchema.extend({
    id: zod_1.z.string().min(1).max(driverFieldMaxLength_1.DRIVER_FIELD_MAX_LENGTH.EXTERNAL_DRIVER_ID),
    firstName: zod_1.z.string().trim().max(driverFieldMaxLength_1.DRIVER_FIELD_MAX_LENGTH.NAME).nullable().optional(),
    lastName: zod_1.z.string().trim().max(driverFieldMaxLength_1.DRIVER_FIELD_MAX_LENGTH.NAME).nullable().optional(),
    login: zod_1.z.string().max(driverFieldMaxLength_1.DRIVER_FIELD_MAX_LENGTH.LOGIN).nullable().optional(),
});
exports.PlatformScienceDriversResponseSchema = zod_1.z.object({
    drivers: zod_1.z.array(exports.PlatformScienceDriverRecordSchema),
});
exports.PlatformScienceUnitSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    assetType: zod_1.z.number().int(),
    enabled: zod_1.z.boolean(),
    updatedAt: zod_1.z.string(),
    phone: zod_1.z.string().nullable().optional(),
});
exports.PlatformScienceUnitsResponseSchema = zod_1.z.object({
    units: zod_1.z.array(exports.PlatformScienceUnitSchema),
});
//# sourceMappingURL=platformScience.js.map